import './AfterSignUp.scss';

import tick from 'assets/images/approved-checked.png';
import logo from 'assets/images/planera-logo.png';

export default function AfterSignUp() {
  return (
    <div className="afterSignupWrapper">
      <div className="logoSection">
        <img
          className="logo"
          alt="Planera logo"
          src={logo}></img>
      </div>
      <div className="messageWrapper">
        <div className="tickWrap">
          <img
            className="logo"
            alt="Invitatioon sent"
            src={tick}></img>
        </div>
        <div className="mainLabel">Planera is currently invite only</div>
        <div className="subLabel">We will review your account and send you a confirmation link via email within 24 hours</div>
      </div>
      <div className="footerSection">© 2022 Planera.io All Rights Reserved</div>
    </div>
  );
}
